/**
 * Component for displaying the playoff tournament bracket for nationals
 * WARNING dummy data
 * Does not currently account for byes, only works for 8 or 4 team brackets
 * Need to be careful with size of names eg only coded to work with LEE B etc
 */
import React from "react";
import { Link } from "react-router-dom";
import PlayoffTeam from "./PlayoffTeam";

const Match = ({ matchData, isFinal, gold= false }) => {
  if (!matchData) {
    return null;
  }
  const isTeam1Winner = matchData.home_score > matchData.away_score;
  const isTeam2Winner = matchData.away_score > matchData.home_score;
  // const isFinal = matchData.round === "Final";

  return (
    <div
      className={`group relative flex flex-col xxsm:px-2 xxsm:py-1.5 py-1 px-1.5 mx-1 xxsm:mx-2 xs:mx-4 dark:bg-dark-1 border-2 md:w-40 rounded border-light-3 dark:border-dark-3 ${
        isFinal ? "border-2 w-36 xxsm:w-36" : "w-20 xxsm:w-28"
      }`}
    >
      <Link to={`/game/${matchData.id}`}>
      {!isFinal && (
        <p className="text-center text-xxs md:text-xs mb-0.5 transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
          {matchData.round}
        </p>
      )}
      {/* display BUIHA logo if final */}
      {isFinal && (
        <img
          src={`https://buiha.org.uk/assets/img/icon/150/${gold ? 'nationals' : 'buiha'}.png`}
          alt="BUIHA"
          className="w-20 h-20 mx-auto"
        />
      )}
      <PlayoffTeam played={matchData.played} isFinal={isFinal} id={matchData.home_id} name={matchData.home_name} score={matchData.home_score} img={matchData.home_img} blip={matchData.home_blip} isWinner={isTeam1Winner}/>
      <PlayoffTeam played={matchData.played} isFinal={isFinal} id={matchData.away_id} name={matchData.away_name} score={matchData.away_score} img={matchData.away_img} blip={matchData.away_blip} isWinner={isTeam2Winner}/>
        {matchData.shootout && (
            <p className="text-center text-xxs md:text-xxs mb-0.5">SHOOTOUT</p>
        )}
        {(matchData.played === 0) && (
            <p className="text-center text-xxs md:text-xxs mb-0.5">Face Off: {matchData.face_off}</p>
        )}
      </Link>
    </div>
  );
};

// Main TournamentBracket component
const TournamentBracket = ({ bracket_data, title, gold=false }) => {
  // Process into final, semi-final and quarter-final games
  let final = bracket_data.final;

  let semifinals = final.previous_games;
  let quarterfinals = semifinals.map((game) => game.previous_games).flat();
  let r16s = quarterfinals.map((game) => game.previous_games).flat();

  // check if quarterfinals only contain undefined, if so, set to null
  if (quarterfinals.every((game) => game === undefined)) {
    quarterfinals = [];
  }

  // check if quarterfinals only contain undefined, if so, set to null
  if (r16s.every((game) => game === undefined)) {
    r16s = [];
  }

  return (
    <div className="w-full ">
      <h2 className="text-center text-2xl mb-1 mt-2 font-semibold">{title} Playoffs</h2>
      <div className="flex justify-center items-center border-light-3 dark:border-dark-3 py-2 xs:py-4 border-t-2">
        {/* Content */}
        <div className="flex flex-col items-center justify-center w-full">
          {/* QF 1,3 */}
          {quarterfinals.length > 2 && (
            <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex">
              <Match matchData={quarterfinals[0]} />
              <div className="xs:w-64"></div>
              <Match matchData={quarterfinals[2]} />
            </div>
          )}
          {/* SF1, F, SF2 Content */}
          <div className="my-2 xxsm:my-4 md:my-0 flex flex-row items-center justify-center w-full">
            {/* SF 1 */}
            <Match matchData={semifinals[0]} />
            {/* Final */}
            <Match matchData={final} isFinal={true} gold={gold} />
            {/* SF 2 */}
            <Match matchData={semifinals[1]} />
          </div>
          {/* QF 2,4 */}
          {quarterfinals.length > 2 && (
              <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex">
                <Match matchData={quarterfinals[1]} />
                <div className="xs:w-64"></div>
                <Match matchData={quarterfinals[3]} />
              </div>
          )}
          {quarterfinals.length === 1 && (
              <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex">
                <div className="xs:w-52"></div>
                <div className="xs:w-64"></div>
                <Match matchData={quarterfinals[0]}/>
              </div>
          )}
          {quarterfinals.length === 2 && (
              <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex">
                <Match matchData={quarterfinals[1]} />
                <div className="xs:w-64"></div>
                <Match matchData={quarterfinals[0]} />
              </div>
          )}
          {r16s.length === 2 && (
              <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex mt-8">
                <Match matchData={r16s[1]}/>
                <div className="xs:w-52"></div>
                <div className="xs:w-16"></div>
                <div className="xs:w-52"></div>
                <Match matchData={r16s[0]}/>
              </div>
          )}
          {r16s.length === 4 && (
              <div className="flex flex-row items-center justify-between xs:justify-center w-full rounded-md flex mt-8">
                <Match matchData={r16s[2]}/>
                <Match matchData={r16s[3]}/>
                <div className="xs:w-16"></div>
                <Match matchData={r16s[0]}/>
                <Match matchData={r16s[1]}/>
              </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TournamentBracket;
